import React from 'react';
import '../userAcc.modules.css';
import { 
  FaUserAlt,  
  FaSignOutAlt, 
} from 'react-icons/fa';
import { useNavigate } from 'react-router-dom'; 
import { useDispatch, useSelector } from 'react-redux';
import { deleteAllCart } from '../../Redux/CartSlice';
import { clearUserID } from '../../Redux/UserSlice';
import { toast } from 'react-toastify';
// import "../App.css";    
 

const Dashboard = () => {

  
  const notify = () => {
    toast(`You're now logged out.`, {
      position: "bottom-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark",
    });
  };
  const iconStyle = { };
  const username = useSelector((state) => state.user.name);
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const handleLogout = ()=>{
    
    notify();
    dispatch(deleteAllCart());
    dispatch(clearUserID()); 
    navigate('/home');
  }

  return (
    <>
      <div className="Outer-UA">
        <div className="Inner1-UA">
          <h1 style={{ marginTop: "20px", fontSize:'1.5rem', textAlign:'center' }}>My Account</h1>
          <br />
          <ul style={{ listStyle: "none" }}>  
            <li style={{ margin: "6px", fontWeight:'700',display:'flex' }}>
              <FaUserAlt style={iconStyle} /> 
              <h6 className='accountDetails' style={{fontWeight:800}}>Accounts Details</h6>
            </li> 
            <li style={{ margin: "6px" }}>
            <div onClick={()=>handleLogout()} style={{display:'flex'}}><FaSignOutAlt style={iconStyle} /> 
            <h6 className='accountDetails'>Logout</h6></div></li>
          </ul>
        </div>
        <div className="Inner2-UA">
          <div className="inner2-UA">
            <p style={{ paddingTop: "30px"}}>
              Hello {username}!
              <br />
              <br />
              From this Dashboard, you can manage your account details.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
